import './SeeingStone.css'

import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar'
import { URL } from '../components/constants';

export default function SeeingStone() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchImages() {
      try {
        const res = await fetch(`${URL}/s3/images`, {
          credentials: "include", // so cookies are sent
        });
        const data = await res.json();
        setImages(data);
      } catch (err) {
        console.error("Error fetching images:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchImages();
  }, []);

  if (loading) return <div><Navbar /></div>;
  if (!images.length) return <p>No images found.</p>;

  return (
  	<div>
	  	<Navbar />
	    <div style={{ padding: "20px" }}>
	      <h1>Mirror of Galadriel</h1>
	      I’m seeing a lot of things... and not all of them look good.
	      <div
	        style={{
	          display: "grid",
	          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
	          gap: "20px",
	        }}
	      >
	        {images.map((img) => (
	          <div key={img.key} style={{ textAlign: "center" }}>
	            <img
	              src={img.url}
	              alt={img.key}
	              style={{ width: "100%", height: "auto", borderRadius: "8px" }}
	            />
	            <p style={{ marginTop: "8px" }}>{img.key}</p>
	          </div>
	        ))}
	      </div>
	    </div>
	</div>
  );
}